module.exports = __webpack_public_path__ + "img/logo.9f7c7ece.webp";